<template>
    <div class="mb-5">
        <label v-if="label" class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ label }}
            <c-info class="inline align-bottom" v-if="info" :info="info" />
        </label>
        <select
            id="proba"
            v-model="model"
            @change="emitChange()"
            class="block w-full pl-3 pr-10 py-2 text-base text-black bg-white border-gray-300 rounded-md sm:text-sm dark:bg-dark-950 dark:text-white dark:border-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            :class="[focus ? 'ring-4 ring-green-500 ring-offset-4' : '']"
        >
            <option disabled value="" :key="-1">{{ placeholder }}</option>
            <template v-if="isListOfObjects">
                <option v-for="{ id, value } in list" :value="id" :key="id">
                    {{ value }}
                </option>
            </template>
            <template v-else>
                <option
                    v-for="(item, index) in list"
                    :value="valueKey ? item[valueKey] : item"
                    :key="index"
                >
                    {{ nameKey ? item[nameKey] : item }}
                </option>
            </template>
        </select>
    </div>
</template>

<script>
import cInfo from "./cInfo.vue";
export default {
    name: "cSelect",
    props: {
        label: String,
        placeholder: String,
        list: Array, // @info: since now, list can be either array of objects ({id: string | number, value: string}) or array of (string | number)[]
        modelValue: [String, Number],
        nameKey: String,
        valueKey: String,
        focus: Boolean,
        info: String,
    },
    emits: ["update:modelValue", "change"],
    components: {
        cInfo,
    },
    data() {
        return {
            model: this.modelValue,
        };
    },
    computed: {
        isListOfObjects() {
            const [firstItem] = this.list || [];
            return firstItem && typeof firstItem === "object";
        },
    },
    methods: {
        emitChange() {
            this.$emit("update:modelValue", this.model);
            this.$emit("change", this.model);
        },
    },
    watch: {
        modelValue: {
            handler(value) {
                this.model = value;
                // This not suppose to be here due to Vuex bugs (hasChanges):
                // this.emitChange();
            },
            // immediate: true,
        },
    },
};
</script>
